import { RichText, RichTextBlock } from 'prismic-reactjs'

export const richTextAsText = (input?: unknown): string => RichText.asText((input || []) as RichTextBlock[])
